import React, { useState, useEffect } from 'react';
import { getSettings, updateSetting } from './adminApi';
import './Settings.css';

const Settings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editedValues, setEditedValues] = useState({});

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const result = await getSettings();
      setSettings(result);
      
      // 初始化编辑值
      const initial = {};
      Object.entries(result).forEach(([key, val]) => {
        initial[key] = val.value;
      });
      setEditedValues(initial);
    } catch (err) {
      console.error('获取设置失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (key) => {
    try {
      setSaving(true);
      await updateSetting(key, editedValues[key]);
      await fetchSettings();
      alert('保存成功');
    } catch (err) {
      alert(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (key, value) => {
    setEditedValues(prev => ({ ...prev, [key]: value }));
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-spinner"></div>
      </div>
    );
  }

  const settingGroups = [
    {
      title: '基础设置',
      keys: ['site_name', 'registration_enabled', 'default_user_role']
    },
    {
      title: '安全设置',
      keys: ['jwt_expire_hours', 'max_file_size_mb']
    },
    {
      title: '存储设置',
      keys: ['file_retention_days']
    }
  ];

  return (
    <div className="settings-page">
      <h2 className="page-title">系统设置</h2>

      {settingGroups.map(group => (
        <div key={group.title} className="admin-card">
          <div className="admin-card-header">
            <h3 className="admin-card-title">{group.title}</h3>
          </div>
          <div className="settings-list">
            {group.keys.map(key => {
              const setting = settings[key];
              if (!setting) return null;
              
              const isBoolean = setting.value === 'true' || setting.value === 'false';
              const isNumber = !isNaN(Number(setting.value)) && setting.value !== '';
              
              return (
                <div key={key} className="setting-item">
                  <div className="setting-info">
                    <div className="setting-label">{key}</div>
                    <div className="setting-desc">{setting.description}</div>
                  </div>
                  <div className="setting-control">
                    {isBoolean ? (
                      <select
                        className="admin-select"
                        value={editedValues[key] || 'false'}
                        onChange={(e) => handleChange(key, e.target.value)}
                      >
                        <option value="true">是</option>
                        <option value="false">否</option>
                      </select>
                    ) : isNumber ? (
                      <input
                        type="number"
                        className="admin-input"
                        value={editedValues[key] || ''}
                        onChange={(e) => handleChange(key, e.target.value)}
                      />
                    ) : (
                      <input
                        type="text"
                        className="admin-input"
                        value={editedValues[key] || ''}
                        onChange={(e) => handleChange(key, e.target.value)}
                      />
                    )}
                    <button
                      className="admin-btn admin-btn-primary"
                      onClick={() => handleSave(key)}
                      disabled={saving || editedValues[key] === setting.value}
                    >
                      保存
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* 说明 */}
      <div className="admin-card">
        <div className="admin-card-header">
          <h3 className="admin-card-title">设置说明</h3>
        </div>
        <div className="settings-help">
          <table className="admin-table">
            <thead>
              <tr>
                <th>设置项</th>
                <th>说明</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>site_name</code></td>
                <td>系统显示名称，显示在页面标题处</td>
              </tr>
              <tr>
                <td><code>registration_enabled</code></td>
                <td>是否开放用户注册功能</td>
              </tr>
              <tr>
                <td><code>default_user_role</code></td>
                <td>新注册用户的默认角色代码</td>
              </tr>
              <tr>
                <td><code>jwt_expire_hours</code></td>
                <td>JWT Token 过期时间（小时）</td>
              </tr>
              <tr>
                <td><code>file_retention_days</code></td>
                <td>生成文件保留天数，超过后可自动清理</td>
              </tr>
              <tr>
                <td><code>max_file_size_mb</code></td>
                <td>上传/生成文件大小限制（MB）</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Settings;